export { CategoryService } from './category';

/* Interfaces */
export type {
  Category,
  CategoryPriceFacet,
  CategoriesBreadcrumb,
  RecentlyViewedCategory,
  CategoriesWithRecent
} from './interfaces';
